// extracted by mini-css-extract-plugin
export default {"-large":"shape-masking-panel-module__-large--kFmtJ","smallTool":"shape-masking-panel-module__smallTool--z2ys_","bigTool":"shape-masking-panel-module__bigTool--DiZJ7"};